import React, { useState } from "react";

const PlaybookContext = React.createContext({
  isOpenModal: false,
  updateOpenModal: () => {},
  isAddMode: true,
  updateAddMode: () => {},
  editData: {},
  updateEditData: () => {},
});

export const PlaybookContextProvider = ({ children }) => {
  const [isOpenModalState, setIsOpenModalState] = useState(false);
  const [isAddModeState, setIsAddModeState] = useState(true);
  const [editDataState, setEditDataState] = useState({});

  const contextValue = {
    isOpenModal: isOpenModalState,
    updateOpenModal: setIsOpenModalState,
    isAddMode: isAddModeState,
    updateAddMode: setIsAddModeState,
    editData: editDataState,
    updateEditData: setEditDataState,
  };

  return (
    <PlaybookContext.Provider value={contextValue}>
      {children}
    </PlaybookContext.Provider>
  );
};

export default PlaybookContext;
